import React from 'react';
import Markdown from 'markdown-to-jsx';
import { ServiceLevelType } from '../../../constants/service-level-type';
import IconTooltip from '../icon-tooltip/icon-tooltip';
import { SLAIcon } from '../../atoms/icons/icons';
import {
  preferredProgramAccessibilityLabel,
  preferredProgramTooltipContent,
  preferredProgramTooltipHeading,
} from '../../../data/preferred-program';
import { replaceAttrSpaceWithHyphen } from '../../../utils/string-helpers/replace-attr-space-with-hyphen';
import colorStyle from '../../../styles/utils/variables.module.scss';
import { CourseListItem } from '../../../models/courses/CourseListModel';
import styles from './course-list.module.scss';
import Link from 'next/link';
import { ApplicationType } from '../../../constants/application-type';

type CourseListProps = {
  courses: CourseListItem[];
  title?: string;
  intro?: any;
  groupName: string;
  programName: string;
  application: string;
};

export default function CourseList({
  courses,
  groupName,
  title,
  intro,
  programName,
  application,
}: CourseListProps) {
  const singlePageGroups = ['International Direct', 'Direct Entry', 'DEW'];
  const showAsOneLink = singlePageGroups.includes(groupName);
  if (groupName == 'International Direct' || groupName == 'Direct Entry' || groupName == 'DEW') {
    programName = 'summary';
  }
  // TODO
  /* Not my best idea
   * anyways, we need to update this when we work on Summary pages
   */
  const disableSpecialCourseLink = courses
    .filter((course) => singlePageGroups.includes(course.programGroup))
    .some((el) => el.disableCourseLink);

  // Hide DE Course on University of Stirling Course List page for INTOStudy
  let hideOnISflagDeStirling = true;
  if (
    application == 'IntoStudy' &&
    courses.some((el) => el.brandId == '2Yim49mzkICYWI44cou4sa') &&
    courses.some((el) => el.route == 'DirectEntry')
  ) {
    hideOnISflagDeStirling = false;
  }

  return (
    <div className={`${styles['courses']}`}>
      {hideOnISflagDeStirling && (
        <>
          <h5 className={'mb-3'}>{title || groupName}</h5>
          {intro && <Markdown>{intro}</Markdown>}
        </>
      )}
      <ul className={`${styles['courses-list']}`}>
        {showAsOneLink && hideOnISflagDeStirling && (
          <li>
            {disableSpecialCourseLink ? (
              <>
                {title === 'Undergraduate Transfer Program' || title === 'Transfer Program'
                  ? title
                  : `${title} ${programName}`}
              </>
            ) : (
              <Link href={`${programName}/${courses[0]?.slug}`}>
                {title === 'Undergraduate Transfer Program' || title === 'Transfer Program'
                  ? title
                  : `${title} ${programName}`}
              </Link>
            )}

            {courses.some((el) => el.serviceLevel?.includes(ServiceLevelType.Premium)) &&
              application == ApplicationType.PartnerPortal && (
                <IconTooltip
                  svgIcon={SLAIcon()}
                  tooltipAccessibilityLabel={preferredProgramAccessibilityLabel}
                  heading={preferredProgramTooltipHeading}
                  svgIconColor={colorStyle.red100}
                  activeSVGIconColor={colorStyle.red200}
                  heapIdentifier={replaceAttrSpaceWithHyphen(preferredProgramTooltipHeading)}
                  heapDataContent={title}
                  helperClass='ms-2'
                >
                  <Markdown>{preferredProgramTooltipContent()}</Markdown>
                </IconTooltip>
              )}
          </li>
        )}

        {!showAsOneLink &&
          courses
            .sort((a, b) => a.name.localeCompare(b.name))
            .filter((course) => course.slug)
            .map((course) => (
              <li key={course.id}>
                {course.slug && !course.disableCourseLink ? (
                  <Link href={`${programName}/${course.slug}`}>{course.name}</Link>
                ) : (
                  course.name
                )}
                {course.serviceLevel?.includes(ServiceLevelType.Premium) &&
                  application == ApplicationType.PartnerPortal && (
                    <IconTooltip
                      svgIcon={SLAIcon()}
                      tooltipAccessibilityLabel={preferredProgramAccessibilityLabel}
                      heading={preferredProgramTooltipHeading}
                      svgIconColor={colorStyle.red100}
                      activeSVGIconColor={colorStyle.red200}
                      heapIdentifier={replaceAttrSpaceWithHyphen(preferredProgramTooltipHeading)}
                      heapDataContent='Direct entry'
                      helperClass='ms-2'
                    >
                      <Markdown>{preferredProgramTooltipContent()}</Markdown>
                    </IconTooltip>
                  )}
              </li>
            ))}
      </ul>
    </div>
  );
}
